<div class="container" id="servicemaindiv">
  <div class="header-row">
    <div class="button-group">
      <button mat-button (click)="openAddUpdateClientModal()">Add Client</button>
    </div>
  </div>
  <div class="table-container">
    <mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="code">
        <mat-header-cell *matHeaderCellDef>
          Client Code
        </mat-header-cell>
        <mat-cell *matCellDef="let item">
          {{item.code}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="title">
        <mat-header-cell *matHeaderCellDef>
          Title
        </mat-header-cell>
        <mat-cell *matCellDef="let item">
          {{item.title}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="description">
        <mat-header-cell *matHeaderCellDef>
          Description
        </mat-header-cell>
        <mat-cell *matCellDef="let item">
          {{item.description}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="services">
        <mat-header-cell *matHeaderCellDef>
          Associated Services
        </mat-header-cell>
        <mat-cell *matCellDef="let item">
          <button mat-button (click)="viewServices(item)">View</button>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="action">
        <mat-header-cell *matHeaderCellDef>
          Action
        </mat-header-cell>
        <mat-cell *matCellDef="let item">
          <div class="button-group action-buttons">
            <button mat-button (click)="openAddUpdateClientModal(item)">Edit</button>
            <button mat-button (click)="openConfirmationDialog(item)">Delete</button>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
  </div>
</div>